let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3lt2R")).then(() => parcelRequire('g8FUI'));